module.exports = __webpack_public_path__ + "img/banner_sonyday.7a4b8446.png";